import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"


import ContextConsumer from "../components/context"

import "../components/index_page/index_page"

import "../components/app_styles.scss"
import IndexPage from "../components/index_page/index_page"

import windowDimensions from "../components/useWindowDimensions"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/pro-light-svg-icons';
import backGroundIntro from "../images/IntroBG.jpg";
const Index = props => {
  const data = useStaticQuery(graphql`
    {
      file(name: {eq: "0"}, relativeDirectory: {eq: "heros"}) {
        childImageSharp {
          fluid(maxWidth: 2880, maxHeight: 2880, quality: 80) {
            ...GatsbyImageSharpFluid
            presentationWidth
          }
        }
      }
    }
  `)
  const backGStyle = {
	  backgroundImage: "url(" + backGroundIntro + ")",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
	  width: "100%",
      position: "absolute",
	  height: "100vh",
	  left: 0,
	  right: 0,
	  top:0,
	  bottom:0,
	  opacity: .3,
	  zIndex: 1,
  }
  
  const {height, width} = windowDimensions()
  
  // console.log(height, width)
  return (
    <ContextConsumer>
      {({ contextData, set, navigatePage }) => {
        return (
          <div>
            <IndexPage 
              headerOffset={ width < 642 ? 50 : 70.81}
              setContext={(newContext)=>{set(newContext)}}
              appWidth={width}
            />
          </div>
        )
      }}
    </ContextConsumer>
  )
}

export default Index
